/**
 * Judge.me Carousel Widget - Performance & SEO Optimizer
 * - Fügt aussagekräftige alt-Tags hinzu (erste 5 Wörter des Produktnamens)
 * - Aktiviert Lazy Loading (loading="lazy")
 * - Optimiert Bildgröße (imgix URL Parameter)
 * - Async Decoding für bessere Performance
 */

(function() {
  'use strict';

  // Funktion: Erste 5 Wörter aus Text extrahieren
  function getFirstFiveWords(text) {
    if (!text) return 'Customer review photo';

    // HTML entities dekodieren und trimmen
    const decoded = text.trim().replace(/&amp;/g, '&');

    // In Wörter aufteilen und erste 5 nehmen
    const words = decoded.split(/\s+/).slice(0, 5);
    return words.join(' ');
  }

  // Funktion: Alt-Tags, Lazy Loading und Performance-Optimierung für Carousel-Card
  function fixAltTagsForCard(card) {
    // Produktname finden
    const productNameEl = card.querySelector('.jdgm-product-name a, .jdgm-product-name');
    if (!productNameEl) return;

    const productName = productNameEl.textContent || productNameEl.innerText;
    const altText = getFirstFiveWords(productName);

    // Alle Bilder in dieser Card finden
    const images = card.querySelectorAll('img');
    images.forEach(img => {
      // 1. Alt-Tag setzen (SEO)
      if (!img.hasAttribute('alt') || !img.getAttribute('alt') || img.getAttribute('alt').trim() === '') {
        img.setAttribute('alt', altText);
      }

      // 2. Lazy Loading aktivieren (Performance)
      if (!img.hasAttribute('loading')) {
        img.setAttribute('loading', 'lazy');
      }

      // 3. Async Decoding für bessere Performance
      if (!img.hasAttribute('decoding')) {
        img.setAttribute('decoding', 'async');
      }

      // 4. Bildgröße optimieren (imgix URL Parameter anpassen)
      // Ändere w=1024 zu w=400 für Carousel-Bilder (reicht für max 400px Breite)
      const currentSrc = img.getAttribute('src');
      if (currentSrc && currentSrc.includes('judgeme.imgix.net') && currentSrc.includes('w=1024')) {
        const optimizedSrc = currentSrc.replace('w=1024', 'w=400');
        img.setAttribute('src', optimizedSrc);
      }

      // Auch data-src behandeln (falls Lazy Loading von Judge.me verwendet wird)
      const dataSrc = img.getAttribute('data-src');
      if (dataSrc && dataSrc.includes('judgeme.imgix.net') && dataSrc.includes('w=1024')) {
        const optimizedDataSrc = dataSrc.replace('w=1024', 'w=400');
        img.setAttribute('data-src', optimizedDataSrc);
      }
    });
  }

  // Funktion: Alle Carousel-Cards prüfen
  function checkAllCarouselCards() {
    // Alle Carousel-Items finden
    const cards = document.querySelectorAll('.jdgm-carousel-item, .jdgm-card.jdgm-media-card');

    cards.forEach(card => {
      // Nur Cards bearbeiten die noch nicht bearbeitet wurden
      if (!card.hasAttribute('data-alt-fixed')) {
        fixAltTagsForCard(card);
        card.setAttribute('data-alt-fixed', 'true');
      }
    });
  }

  // MutationObserver: Beobachtet neue/geänderte Carousel-Cards
  function observeCarousel() {
    const targetNode = document.body;

    const observer = new MutationObserver((mutations) => {
      let shouldCheck = false;

      mutations.forEach(mutation => {
        // Neue Nodes hinzugefügt?
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) { // Element Node
              // Ist es eine Carousel-Card oder das Widget selbst?
              if (node.classList?.contains('jdgm-carousel-item') ||
                  node.classList?.contains('jdgm-cards-carousel') ||
                  node.querySelector?.('.jdgm-carousel-item, .jdgm-cards-carousel')) {
                shouldCheck = true;
              }
            }
          });
        }

        // Attribute geändert? (z.B. class="active" oder style changes)
        if (mutation.type === 'attributes' &&
            (mutation.target.classList?.contains('jdgm-carousel-item') ||
             mutation.target.classList?.contains('jdgm-cards-carousel'))) {
          shouldCheck = true;
        }
      });

      if (shouldCheck) {
        // Kleine Verzögerung um sicherzugehen dass das DOM vollständig ist
        setTimeout(checkAllCarouselCards, 100);
      }
    });

    // Observer starten
    observer.observe(targetNode, {
      childList: true,      // Neue/entfernte Nodes
      subtree: true,        // Alle Nachkommen beobachten
      attributes: true,     // Attribut-Änderungen (z.B. class, style)
      attributeFilter: ['style', 'class'] // Nur relevante Attribute
    });

    // Initial-Check (falls Widget schon geladen ist)
    checkAllCarouselCards();

    // Zusätzlicher Check nach 2 Sekunden (falls Widget später lädt)
    setTimeout(checkAllCarouselCards, 2000);
  }

  // Warten bis DOM bereit ist
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCarousel);
  } else {
    observeCarousel();
  }
})();
